import { JSONObject, JSONValue } from '@models';

function formatEnumKey(key: string): string {
  return key.replace(/([a-z])([A-Z])|_/g, '$1 $2');
}

export function convertToKebabCase(key: JSONValue): string {
  return (key && key.toString().toLowerCase().replace(/\s+/g, '-')) || '';
}

export function getEnumKeyByValue(enumObj: JSONObject, value: number): string | undefined {
  return Object.keys(enumObj).find(key => enumObj[key] === value);
}

export function getEnumValueByKey(enumObj: JSONObject, key: string): JSONValue | undefined {
  return enumObj[key];
}

export function getFormattedEnumKeyByValue(enumObj: JSONObject, value: number): string | number {
  const key = getEnumKeyByValue(enumObj, value);
  return key ? formatEnumKey(key) : value;
}

export function getKebabCaseEnumKeyByValue(enumObj: JSONObject, value: number): string | number {
  const formattedKey = getFormattedEnumKeyByValue(enumObj, value);
  return typeof formattedKey === 'string' ? convertToKebabCase(formattedKey) : formattedKey;
}
